import { render, staticRenderFns } from "./accountset.vue?vue&type=template&id=45b8675b&scoped=true&"
import script from "./accountset.vue?vue&type=script&lang=js&"
export * from "./accountset.vue?vue&type=script&lang=js&"
import style0 from "./accountset.vue?vue&type=style&index=0&id=45b8675b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8675b",
  null
  
)

export default component.exports